module.exports = __webpack_public_path__ + "static/media/noImage.d64d8944.png";